import { AppBar, Button, ButtonGroup, Fab, Hidden, MuiThemeProvider, Toolbar, makeStyles, useMediaQuery } from '@material-ui/core';
import { ChatBubble, ShoppingBasket } from '@material-ui/icons';
import { AnalyticsProvider } from '@zennya/web-component-library/src';
import { CustomToaster } from 'components/CustomToaster';
import ScrollToTop from 'components/ScrollToTop';
import { AnimatePresence, LayoutGroup } from 'framer-motion';
import { CLOSE_CHAT, SUPPORT_CHAT, openChatState } from 'pages/CustomerBooking';
import { Chat } from 'pages/CustomerBooking/Chat';
import { Wizard } from 'pages/CustomerBooking/Stepper/Wizard';
import { Suspense, useCallback, useEffect, useMemo } from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import themes from 'themes';
import { Interceptor } from 'util/interceptor';
import { useTrackEvent } from 'util/trackEvent';
import { RecipientScreen } from './0/Recipient';
import { LocationScreen } from './1/Location';
import { ServicePackagesScreen } from './2.2/ServicePackages';
import { ServiceDetails } from './2.3/ServiceDetails';
import { ServiceCostScreen } from './3/ServiceCost';
import { ServiceBreakdownScreen } from './4/ServiceBreakdown';
import { ScheduleScreen } from './5/Schedule';
import { Account } from './6/Account';
import { PersonalDetailsScreen } from './7/1/PersonalDetails';
import { ListRecipientsScreen } from './7/2/ListRecipients';
import { AddRecipientScreen } from './7/2/ListRecipients/1/AddRecipient';
import { BookingAdditionalQuestionsScreen } from './7/3/BookingAdditionalQuestions';
import { PaymentScreen } from './8/Payment';
import { ListPaymentMethodsScreen } from './8/Payment/1/ListPaymentMethods';
import { PostPaymentScreen } from './9/PostPayment';
import { Cart } from './Cart';
import { SideBar, StepComponent } from './SideBar';
import { sessionTokenState, stepState, userState } from './state';
import { Switcher } from './Switcher';
import { anonSessionToken } from 'services/anon.service';
import { AdvertScreen } from './0.1/Advert';
import { BookingList } from './0.2/BookingList';
import { NotFound } from 'pages/NotFound';
import { LinkGenerator } from './LinkGenerator';
import { useCreateBooking } from './createHook';
import { useUserState } from 'services/authentication.service';
import { CartButton } from './components/PageHeader/CartButton';
import { STEP_CART_ENABLED } from './constants';
import { CircularProgress } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100vw',
  },
  layoutRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.down("xs")]: {
      backgroundColor: theme.palette.background.default,
    },
  },
  overPad: {
    height: theme.spacing(8)
  },
  chatFooter: {
    top: 'auto',
    bottom: 0,
    backgroundColor: 'transparent'
  }
}));

const CustomerBookingCreate = ({ }) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()
  const location = useLocation();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [user, setUser] = useRecoilState(userState)
  const [step, setStep] = useRecoilState(stepState);

  // const setChatOpen = useSetRecoilState(openChatState);
  const [chatOpen, setChatOpen] = useRecoilState(openChatState);

  const { clearState } = useCreateBooking()

  const { getIdentity, getUser, logout } = useUserState(clearState)


  const Routes = useMemo(
    () => {
      return (
        <div className={classes.layoutRoot}>
          <ScrollToTop />
          <Switch>
            <Route exact path="/createbooking" component={RecipientScreen} />
            <Route exact path="/createbooking/zennyaapp" component={AdvertScreen} />
            <Route exact path="/createbooking/recipient" component={RecipientScreen} />
            <Route exact path="/createbooking/location" component={LocationScreen} />
            <Route exact path="/createbooking/servicepackages" component={ServicePackagesScreen} />
            <Route exact path="/createbooking/servicedetails" component={ServiceDetails} />
            <Route exact path="/createbooking/servicecost" component={ServiceCostScreen} />
            <Route exact path="/createbooking/servicebreakdown" component={ServiceBreakdownScreen} />
            <Route exact path="/createbooking/schedule" component={ScheduleScreen} />
            <Route exact path="/createbooking/personaldetails" component={PersonalDetailsScreen} />
            <Route exact path="/createbooking/listrecipients" component={ListRecipientsScreen} />
            <Route exact path="/createbooking/addrecipient" component={AddRecipientScreen} />
            <Route exact path="/createbooking/additions" component={BookingAdditionalQuestionsScreen} />
            <Route exact path="/createbooking/payment" component={PaymentScreen} />
            <Route exact path="/createbooking/listpaymentmethods" component={ListPaymentMethodsScreen} />
            <Route path="/createbooking/postpayment" component={PostPaymentScreen} />
            <Route exact path="/createbooking/postpayment/:id" component={PostPaymentScreen} />
            <Route path="/createbooking/account" component={Account} />
            <Route exact path="/createbooking/bookings" component={BookingList} />
            <Route exact path="/createbooking/linkgenerator" component={LinkGenerator} />
            <Route>
              <NotFound />
            </Route>
          </Switch>
          <div className={classes.overPad} />
        </div>
      )
    }, []
  );
  return (
    <AnimatePresence exitBeforeEnter initial>
      <BrowserRouter>
        <CustomToaster
          onChatOpen={() => {
            trackEvent('Toaster open chat')
            setChatOpen(SUPPORT_CHAT)
          }}
        />
        <MuiThemeProvider theme={themes.createBooking}>
          <div className={classes.root}>
            <Cart />
            
            {(process.env.REACT_APP_ENVIRONMENT !== 'local') &&
              <Chat disableMedical serviceId={null} source="B2C" />
            }
            
            <Hidden smUp>
              <Wizard
                isCreate
                isMobile
                current={1}
                onLogout={() => {
                  logout()
                }}
                StepComponent={
                  // <StepComponent step={step} />
                  <></>
                }
              >
                {Routes}
              </Wizard>
            </Hidden>
            <Hidden xsDown>
              <LayoutGroup>
                <SideBar>
                  {Routes}
                </SideBar>
              </LayoutGroup>
            </Hidden>
            {isMobile && (
              <Fab
                style={{
                  display: (chatOpen !== CLOSE_CHAT) ? 'none' : 'flex',
                  position: 'fixed',
                  bottom: 5,
                  left: 5,
                  zIndex: 99999
                }}
                color="secondary"
                size="large"
                onClick={() => {
                  trackEvent('Chat Mobile Bubble - clicked', { 'type': SUPPORT_CHAT })
                  setChatOpen(SUPPORT_CHAT)
                }}
              >
                <ChatBubble />
              </Fab>
            )}
          </div>
        </MuiThemeProvider>
        <Switcher />
      </BrowserRouter>
    </AnimatePresence>
  )
}

const Wrapper = (props) => {
  return (
    <AnalyticsProvider writeKey={process.env.REACT_APP_SEGMENT_KEY} appIdentifier="CLIENT B2C" eventPrefix='B2C'>
      <CustomerBookingCreate {...props} />
    </AnalyticsProvider>
  )
}

export { Wrapper as CustomerBookingCreate };
